var render = function render(){var _vm=this,_c=_vm._self._c;return _c('event-list',{attrs:{"obj-id":_vm.resId,"obj-type":_vm.resType,"list-id":_vm.id,"getParams":_vm.getParams,"enableVirtualScroll":_vm.enableVirtualScroll}})
}
var staticRenderFns = []

export { render, staticRenderFns }